// src/pages/plantation/formula/Calculation.js

const formatResult = (value) => {
  return value === 0 ? null : value;
};

/**
 * Fungsi untuk menghitung nilai K berdasarkan formula:
 * K = (KCl * 0,6) + (K2SO4 * 0,5)
 */
export const calculateK = (kcl, k2so4) => {
  try {
    const kclValue = parseFloat(kcl) || 0;
    const k2so4Value = parseFloat(k2so4) || 0;
    
    const result = (kclValue * 0.6) + (k2so4Value * 0.5);
    
    // Return null jika hasil 0
    return result === 0 ? null : result;
  } catch (error) {
    console.error("Error calculating K:", error);
    return null;
  }
};

/**
 * Fungsi untuk menghitung nilai N berdasarkan formula:
 * N = (UREA * 46%) + (ZA * 21%) + (DAP * 18%)
 */
export const calculateN = (urea, za, dap) => {
  try {
    const ureaValue = parseFloat(urea) || 0;
    const zaValue = parseFloat(za) || 0;
    const dapValue = parseFloat(dap) || 0;
    
    const result = (ureaValue * 0.46) + (zaValue * 0.21) + (dapValue * 0.18);
    
    return result === 0 ? null : result;
  } catch (error) {
    console.error("Error calculating N:", error);
    return null;
  }
};

/**
 * Fungsi untuk menghitung K/N Rasio berdasarkan formula:
 * K/N Rasio = K / N
 */
export const calculateKNRatio = (k, n) => {
  try {
    const kValue = parseFloat(k) || 0;
    const nValue = parseFloat(n) || 0;
    
    if (nValue === 0) {
      return null;
    }
    
    const result = kValue / nValue;
    
    // Return dengan 2 digit desimal jika bukan null
    return result === 0 ? null : parseFloat(result.toFixed(2));
  } catch (error) {
    console.error("Error calculating K/N Ratio:", error);
    return null;
  }
};

/**
 * Fungsi untuk menghitung Setara K2SO4 berdasarkan formula:
 * Setara K2SO4 = (KCl * 60% / 50%) + K2SO4
 * atau: Setara K2SO4 = (KCl * 1.2) + K2SO4
 */
export const calculateSetaraK2SO4 = (kcl, k2so4) => {
  try {
    const kclValue = parseFloat(kcl) || 0;
    const k2so4Value = parseFloat(k2so4) || 0;
    
    const result = (kclValue * 1.2) + k2so4Value;
    
    return result === 0 ? null : result;
  } catch (error) {
    console.error("Error calculating Setara K2SO4:", error);
    return null;
  }
};

/**
 * Fungsi untuk menghitung Setara Urea berdasarkan formula:
 * Setara Urea = (ZA * 21 / 46) + (DAP * 18 / 46) + UREA
 * atau: Setara Urea = (ZA * 0.4565) + (DAP * 0.3913) + UREA
 */
export const calculateSetaraUrea = (za, dap, urea) => {
  try {
    const zaValue = parseFloat(za) || 0;
    const dapValue = parseFloat(dap) || 0;
    const ureaValue = parseFloat(urea) || 0;
    
    const result = (zaValue * 0.4565) + (dapValue * 0.3913) + ureaValue;
    
    return result === 0 ? null : result;
  } catch (error) {
    console.error("Error calculating Setara Urea:", error);
    return null;
  }
};

/**
 * Fungsi utama untuk menghitung semua nilai berdasarkan data input
 */
export const calculateAllValues = (data) => {
  try {
    // Ekstrak nilai dari data
    const { kcl = 0, k2so4 = 0, za = 0, dap = 0, urea = 0 } = data;
    
    // Hitung K
    const k = calculateK(kcl, k2so4);
    
    // Hitung N
    const n = calculateN(urea, za, dap);
    
    // Hitung K/N Rasio
    const knRatio = calculateKNRatio(k, n);
    
    // Hitung Setara K2SO4
    const setaraK2SO4 = calculateSetaraK2SO4(kcl, k2so4);
    
    // Hitung Setara Urea
    const setaraUrea = calculateSetaraUrea(za, dap, urea);
    
    // Return semua hasil perhitungan
    return {
      k,
      n,
      knRatio,
      setaraK2SO4,
      setaraUrea
    };
  } catch (error) {
    console.error("Error in calculateAllValues:", error);
    return {
      k: 0,
      n: 0,
      knRatio: 0,
      setaraK2SO4: 0,
      setaraUrea: 0
    };
  }
};